import React, { useEffect, useState } from "react";
import "./othersmodule.css";
import CancelIcon from "@mui/icons-material/Cancel";
import instance from "../../ApiInstance/Inetrceptor";
import {
  Drawer,
  Grid,
  Button,
  InputLabel,
  FormControl,
  TextField,
  InputAdornment,
  Typography,
  Autocomplete,
  Alert,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CustomTheme from "../../Customtheme/Themes";

const MessageScreenTypesDrawer = ({
  getMessageScreenType,
  setIsDrawerOpen,
  isDrawerOpen,
  drawerCaller,
  setBackDrop,
  dropDownInformation,
  setDropdownvisble,
  getMessageType,
  dropdownvisble
  
}) => {
  const type = drawerCaller?.name ?? "Add";
  const filledInfo = drawerCaller?.data ?? {};
  const { category, messageType, setMessageType, RoutingStatus, MaintainData } =
    dropDownInformation;
  const { drawerWidth, isXs, isSm, isMd, isLg, isXl } = CustomTheme();
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [information, setInformation] = useState({});
  const handleDrawerClose = (event) => {
    setIsDrawerOpen(false);
    setMessageType([]);
  };
  const createNewMessageScreenType = () => {
    const source_entity_id = information?.source_entity_id;
    const message_type_id = information?.message_type_id;
    const destination_entity_id = information?.destination_entity_id;
    const message_routing_status_id = information?.message_routing_status_id;

    if (
      source_entity_id == 0 ||
      message_type_id == 0 ||
      destination_entity_id == 0 ||
      message_routing_status_id == 0
    ) {
      setError("Please fill all the mandatory fields");
      setTimeout(() => {
        setError(null);
      }, 5000);
      return;
    }
    setBackDrop(true);
    const body = {
      message_type_routing_id: information?.message_type_routing_id,
      message_type_id: information?.message_type_id,
      source_entity_id: information?.source_entity_id,
      destination_entity_id: information?.destination_entity_id,
      message_routing_status_id: information?.message_routing_status_id,
    };
    instance
      .post("api/v1/Master/MessageTypeRouting/Post", body)
      .then((res) => {
        if (res?.data?.Success) {
          setError(null);
          setSuccess(res?.data?.ResultMessage);
          getMessageScreenType();
          setMessageType([])
          setTimeout(() => {
            setSuccess(null);
          }, 5000);
        } else {
          setError(res?.data?.ResultMessage);
          setTimeout(() => {
            setError(null);
          }, 5000);
        }
        setInformation({
          message_type_routing_id:0,
          message_type_id: 0,
          source_entity_id: 0,
          destination_entity_id: 0,
          message_routing_status_id: 0,
        });
       
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setBackDrop(false); 
      });
  };
  useEffect(() => {
    setInformation({
      message_type_routing_id: filledInfo?.message_type_routing_id ?? 0,
      message_type_id: filledInfo?.message_type_id ?? 0,
      source_entity_id: filledInfo?.source_entity_id ?? 0,
      destination_entity_id: filledInfo?.destination_entity_id ?? 0,
      message_routing_status_id: filledInfo?.message_routing_status_id ?? 0,
    });
  }, [drawerCaller]);
  const handleClick = () => {
    if (dropdownvisble.length >= 3) {
      getMessageType();
    }
  };
  messageType?.find(
    (obj) =>{
      console.log("obj",obj,filledInfo,MaintainData);
     return obj?.message_type_id === information?.message_type_id
    }
  ) 
  return (
    <Drawer
      anchor="right"
      open={isDrawerOpen}
      PaperProps={{
        sx: {
          width: drawerWidth,
        },
      }}
    >
      <div style={{ padding: "20px" }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Button
              id="back-button"
              variant="contained"
              color="transparent"
              className="button_backOthr"
              onClick={handleDrawerClose}
              startIcon={<ArrowBackIcon onClick={handleDrawerClose} />}
            >
              Back
            </Button>
          </Grid>
          <Grid item xs={12}>
            <Typography
              variant="h5"
              className="font-colorOthr mb-0"
              style={{ fontWeight: "600" }}
            >
              {type == "Add" ? "Add" : "Edit"} Message Routing{" "}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography
              variant="h7"
              className="font-colorOthr mb-1"
              style={{ fontWeight: "600" }}
            >
              Message Routing Information{" "}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            {error && (
              <Alert
                variant="outlined"
                severity="error"
                icon={
                  <CancelIcon
                    onClick={() => setError(null)}
                    style={{ cursor: "pointer" }}
                  />
                }
                className="errorAlertMaintain mt-4"
              >
                {error}
              </Alert>
            )}
            {success && (
              <Alert
                variant="outlined"
                severity="success"
                className="sucessAlertMaintain mt-4"
              >
                {success}
              </Alert>
            )}
          </Grid>
          <Grid item xs={12}>
            <InputLabel htmlFor="source_entity_id">
              Source Entity<span style={{ color: "red" }}>*</span>
            </InputLabel>
            <FormControl variant="outlined" fullWidth>
              <Autocomplete
                id="source_entity_id"
                options={MaintainData}
                value={
                  MaintainData.find(
                    (obj) => obj?.entity_id === information?.source_entity_id
                  ) || null
                }
                getOptionLabel={(option) => option?.entity_name}
                onChange={(event, value) => {
                  setInformation((prev) => {
                    return {
                      ...prev,
                      source_entity_id: value?.entity_id,
                    };
                  });
                }}
                disableClearable
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    variant="outlined"
                    // InputProps={{
                    //   ...params.InputProps,
                    //   endAdornment: (
                    //     <InputAdornment
                    //       position="end"
                    //       style={{ position: "absolute", right: 20 }}
                    //     >
                    //       <img src="assets/Images/searchicon.svg"></img>
                    //     </InputAdornment>
                    //   ),
                    // }}
                  />
                )}
              />
            </FormControl>
          </Grid>
     
          <Grid item xs={12}>
            <InputLabel htmlFor="message_type_id">
              Message Type<span style={{ color: "red" }}>*</span>
            </InputLabel>
            <FormControl variant="outlined" fullWidth>
              <Autocomplete
                id="message_type_id"
                options={messageType}
                getOptionLabel={(option) => option.message_type_name}
                value={
                  messageType.length ?
                    messageType?.find(
                        (obj) =>{
                         return obj?.message_type_id === information?.message_type_id
                        }
                      ) : null
                }
                onChange={(event, value) => {
                  setInformation((prev) => {
                    return {
                      ...prev,
                      message_type_id: value?.message_type_id,
                    };
                  });
                }}
                
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    variant="outlined"
                    onChange={(event) => {
                      setDropdownvisble(event.target.value);
                      if (event.target.value.length < 3) {
                        setMessageType([])
                      }
                     
                    }}
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <InputAdornment
                          position="end"
                          style={{ position: "absolute", right: 20 ,cursor:"pointer"}}
                          onClick={handleClick}>
                          <img src="assets/Images/searchicon.svg"></img>
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
              />
              
            </FormControl>
          {console.log( "loggg",messageType?.find(
                  (obj) =>
                    obj?.message_type_id === information?.message_type_id
                ))}
          </Grid>
          <Grid item xs={12}>
            <InputLabel htmlFor="destination_entity_id">
              Destination Entity <span style={{ color: "red" }}>*</span>
            </InputLabel>
            <FormControl variant="outlined" fullWidth>
              <Autocomplete
                id="destination_entity_id"
                options={MaintainData}
                getOptionLabel={(option) => option.entity_name}
                value={
                  MaintainData.find(
                    (obj) =>
                      obj?.entity_id === information?.destination_entity_id
                  ) || null
                }
                onChange={(event, value) => {
                  setInformation((prev) => {
                    return {
                      ...prev,
                      destination_entity_id: value?.entity_id,
                    };
                  });
                }}
                disableClearable
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    variant="outlined"
                    // InputProps={{
                    //   ...params.InputProps,
                    //   endAdornment: (
                    //     <InputAdornment
                    //       position="end"
                    //       style={{ position: "absolute", right: 20 }}
                    //     >
                    //       <img src="assets/Images/searchicon.svg"></img>
                    //     </InputAdornment>
                    //   ),
                    // }}
                  />
                )}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <InputLabel htmlFor="message_routing_status_code">
              Message Routing Status <span style={{ color: "red" }}>*</span>
            </InputLabel>
            <FormControl variant="outlined" fullWidth>
              <Autocomplete
                id="message_routing_status_code"
                options={RoutingStatus}
                getOptionLabel={(option) => option.message_routing_status_code}
                value={
                  RoutingStatus.find(
                    (obj) =>
                      obj?.message_routing_status_id ===
                      information?.message_routing_status_id
                  ) || null
                }
                onChange={(event, value) => {
                  setInformation((prev) => {
                    return {
                      ...prev,
                      message_routing_status_id:
                        value?.message_routing_status_id,
                    };
                  });
                }}
                disableClearable
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    variant="outlined"
                    // InputProps={{
                    //   ...params.InputProps,
                    //   endAdornment: (
                    //     <InputAdornment
                    //       position="end"
                    //       style={{ position: "absolute", right: 20 }}
                    //     >
                    //       <img src="assets/Images/searchicon.svg"></img>
                    //     </InputAdornment>
                    //   ),
                    // }}
                  />
                )}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} sx={{ textAlign: "right" }} className="mt-3">
            <Button
              id="back-button"
              variant="contained"
              color="secondary"
              onClick={createNewMessageScreenType}
            >
              {type == "Add" ? "Create" : "Save Changes"}
            </Button>
          </Grid>
        </Grid>
      </div>
    </Drawer>
  );
};

export default MessageScreenTypesDrawer;
